import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Loose scripts, mostly relaxation and box breathing — not connected breath', 'Words for the middle, nothing for the screen, the consent or the close', 'One intensity for every breather, every day', 'Nothing for when tears, strong energy or stillness arrive', '1:1 only — no circles, workshops, retreats or online'];
const withIt = ['Complete sessions built on the five-phase Breath Arc', 'Screening, consent and touch agreed before anyone lies down', 'Gentle, Steady and Full on the Pace Dial, card by card', 'Ready-to-say lines for what arises, plus how to soften or deepen', '1:1, circles, workshops, retreats and online — one method'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-cream" data-id="element-292" data-mp="30yeogmmh3tej">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:py-20" data-id="element-293" data-mp="30x3m8r8oetpj">
        <div className="text-center" data-id="element-294" data-mp="35q53v709p7ct">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-295" data-mp="35r7tlblut3r5">
            Why this isn’t another script bundle
          </p>
          <h2 id="vs-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-296" data-mp="1oh1nqppoz7f0">
            A bundle of scripts vs <em data-id="element-297" data-mp="1yeg3so7pdu6s">a session you can run</em>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-298" data-mp="1ycv98yle2b8x">
            There are breathwork scripts and cue lists everywhere. Having
            words was never the hard part — running a whole connected breath
            session around them is: the screen, the consent, the pace, what to
            say when something arises, how to land it and how to close. That’s
            what this library is built around.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-sand-dark shadow-card" data-id="element-299" data-mp="rphjv3feklxi">
          <div className="bg-sand px-3.5 py-4 sm:p-6" data-id="element-300" data-mp="mrpuoh657dx0">
            <span className="font-display text-xl leading-none text-ink-soft sm:text-3xl" data-id="element-301" data-mp="mt99s4g2bix7">
              Script bundle
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-302" data-mp="2rrh3v3hamhar">
              Scripts, cue lists, PDFs
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-303" data-mp="2vvym2y808mjf">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-304" data-mp="30u8kdhp10399">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-terra/20" data-id="element-305" data-mp="3aq382r83woiw">
                    <XIcon className="h-2.5 w-2.5 text-terra-deep" aria-hidden="true" data-id="element-306" data-mp="3fimumdorutzu" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-sage px-3.5 py-4 text-cream sm:p-6" data-id="element-307" data-mp="3okckvg6x3mw1">
            <span className="font-display text-xl leading-none sm:text-3xl" data-id="element-308" data-mp="3tintxope1td7">
              Session Ready
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-ochre-soft" data-id="element-309" data-mp="7hq5n71fudkc">
              The Breath Arc Method
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-310" data-mp="3tn3qgw500uct">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-311" data-mp="3pm1ldyoeho2x">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-ochre/30" data-id="element-312" data-mp="q8r4zw6h0b4f">
                    <CheckIcon className="h-2.5 w-2.5 text-ochre-soft" aria-hidden="true" data-id="element-313" data-mp="ggtrgirzp72j" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}